'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useIsClient, useNavigatorShare } from '@hivebrite/react-hooks';
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { SocialMediaButtons } from './SocialMediaButtons';
import { availableServices } from '../constants';
const sendIcon = () => (_jsx(FontAwesomeIcon, { height: "28px", iconName: "share", iconType: CATEGORIES.SOLID }));
export const ShareButtons = ({ shareButtonLabel, socialMediaList, title, url, }) => {
    const isClient = useIsClient();
    const shouldRenderSocialMedia = socialMediaList.length > 0;
    // Native share button must occur only if all available services are selected for current event.
    const isAllSocialMediaActivated = Boolean(socialMediaList) &&
        availableServices.every((item) => socialMediaList.includes(item.type));
    const { canShare, handleShare, shareUrl } = useNavigatorShare({
        data: {
            text: title,
            url,
        },
        onShare: () => {
            // this is where amplitude event should be sent
        },
    });
    if (!url && !shouldRenderSocialMedia) {
        return null;
    }
    if (!isClient) {
        return _jsx("div", { style: { height: '48px' } });
    }
    if (isAllSocialMediaActivated && Boolean(canShare)) {
        const shareButtonProps = shareUrl && {
            as: 'a',
            href: shareUrl,
            'data-bypass-router': true,
        };
        return (_jsx(Box, { display: "block", mt: 3, children: _jsx(Button, Object.assign({ icon: sendIcon, onClick: handleShare }, shareButtonProps, { children: shareButtonLabel })) }));
    }
    return (_jsx(Box, { display: "block", mt: 3, children: _jsx(SocialMediaButtons, { socialMediaList: socialMediaList, title: title, url: url }) }));
};
//# sourceMappingURL=ShareButtons.js.map